import Vue from 'vue'
import App from './App.vue'
import store from './store'

window.$ = window.jQuery = require('jquery');

import 'bootstrap';
Vue.config.productionTip = false;
//var modernizr = require("modernizr");
//const modernizr = require("modernizr");


window.subitusPlayer = {}
subitusPlayer = new Vue({
  store,
  render: h => h(App)
}).$mount('#app')

subitusPlayer = subitusPlayer.$children[0];

/*
require('../public/bower_components/jquery-fullscreen/jquery.fullscreen-min.js');

*/

require('imports-loader?this=>window!../public/bower_components/components-modernizr/modernizr.js');
require('../public/bower_components/perfect-scrollbar/js/perfect-scrollbar.jquery.min.js');



	jQuery(document).ready(function() {
		require('imports-loader?$=jquery!../public/assets/js/main.js');
        Main.init();

		console.log('IMPORTS LOADER MODERNIZR');        

		function size() {
	      // you can change here what you prefer
	      if (/android|webos|iphone|ipad|ipod|blackberry|nokia|opera mini|opera mobi|skyfire|maemo|windows phone|palm|iemobile|symbian|symbianos|fennec/i.test(navigator.userAgent.toLowerCase())) {
	        var theminheight = Math.min(document.documentElement.clientHeight, window.screen.height, window.innerHeight);
	        //now apply height ... if needed...add html & body ... i need and i use it
	        jQuery('html body #yourelementofchoise').css('height', theminheight);
	      } else {
	      	jQuery('#app').height(jQuery(window).height());
	      }
	    }
	    window.addEventListener('resize orientationchange', function() {
	      size();
	    }, false);
	    size();

	    window.addEventListener("message", function(event) {

	    	if(event.data !== '')
	    		eval(event.data);

	    }, false);

		
      	subitusPlayer.goToHome();
	    subitusPlayer.scormApi = getAPI();
	    subitusPlayer.lmsStart();
	    
		
    });


//==================================

var _Debug = true;

function dconsole(message) {
	console.log('%c ' + message + ' ', 'background: #222; color: #bada55');
}

// SCORM API
function getAPI(){
   
	var theAPI = findAPI(window.top);
	if (theAPI == null) {
		if (_Debug) {

		    dconsole("checking to see if this window has an opener");
		    dconsole("window.opener typeof is> "+typeof(window.opener));
		}

		if (typeof(window.opener) != "undefined"){
		    if (_Debug){
		        dconsole("checking this windows opener");
		    }
		    if (window.opener != null){
		        if (_Debug){
		            dconsole("this windows opener is NOT null - looking there");
		        }
		        theAPI = findAPI(window.opener.top);
		    }
		    else{
		        if (_Debug){
		            dconsole("this windows opener is null");
		        }
		    }
		}
	}

	return theAPI;
}

function findAPI(win) {    
	if (_Debug){
	    dconsole("win is: "+win.location.href);
	}
	if (win.API != null){
	    if (_Debug){
	        dconsole("found api in this window");
	    }
	    return win.API;
	}
	if (win.length > 0) {
	    if (_Debug){
	    dconsole("looking for api in windows frames");
	    }
	    for (var i=0;i<win.length;i++){

	        if (_Debug){
	            dconsole("looking for api in frames["+i+"]");
	        }
	        var theAPI = findAPI(win.frames[i]);
	        if (theAPI != null){
	            return theAPI;
	        }
	    }
	}
	if (_Debug){
	    dconsole("didn't find api in this window (or its children)");
	}
	return null;
}